/**
 * Get or create a unique visitor ID from localStorage
 */
export const getOrCreateVisitorId = (): string => {
  const STORAGE_KEY = 'visitorId';
  const existingId = localStorage.getItem(STORAGE_KEY);

  if (existingId) {
    return existingId;
  }

  const newId = `visitor_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  localStorage.setItem(STORAGE_KEY, newId);
  return newId;
};

/**
 * Determine media type from file
 */
export const getMediaTypeFromFile = (
  file: File
): 'image' | 'video' | 'audio' | 'document' => {
  const fileType = file.type;

  if (fileType.startsWith('image/')) return 'image';
  if (fileType.startsWith('video/')) return 'video';
  if (fileType.startsWith('audio/')) return 'audio';
  return 'document';
};

/**
 * Format time for display
 */
export const formatMessageTime = (date: Date): string => {
  return new Date(date).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};
